import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import Label from 'shared/components/label';
import DetailValidationFields from './DetailValidationFields';
import FormikDropdown from 'src/components/formik-dropdown';
import FormikTextField from 'src/components/FormikTextField';
import {ordinalNumber} from 'shared/utils';
import Button from 'src/components/button';
import styles from './Details.module.scss';
import {Field} from 'formik';
import Checkbox from 'shared/components/checkbox';

const DETAILS = {
  'TimeSensitiveItemType::ShortTextDetail': 'Short text',
  'TimeSensitiveItemType::LongTextDetail': 'Long text',
  'TimeSensitiveItemType::PhotoDetail': 'Photo',
  'TimeSensitiveItemType::NumberDetail': 'Number',
};

const propTypes = {
  detail: PropTypes.object,
  index: PropTypes.number,
  removeDetail: PropTypes.func,
};

const typeOptions = map(DETAILS, (value, key) => ({_id: value, value: key, text: value}));

const Detail = (props) => {
  const {detail, index, removeDetail} = props;

  return (
    <div key={index} className={styles.fieldBorder}>
      {`${ordinalNumber(index + 1)} Detail`}
      <Label>
        1. Type
        <FormikDropdown name={`details[${index}]._type`} options={typeOptions} />
      </Label>
      <Label>
        {`2. ${DETAILS[detail._type]} question`}
        <FormikTextField name={`details[${index}].question`} placeholder="What did you think?" />
      </Label>
      <Label>
        3. Are students required to answer?
        <Field name={`details[${index}].required`}>
          {({field: {value}, form: {setFieldValue}}) => (
            <Checkbox
              checked={value}
              onClick={(e) => setFieldValue(`details[${index}].required`, e.target.checked)}
            />
          )}
        </Field>
      </Label>
      {detail._type !== 'TimeSensitiveItemType::PhotoDetail' && (
        <DetailValidationFields detail={detail} index={index} />
      )}
      <Button
        aria-label="Remove detail"
        size="small"
        color="negative"
        onClick={removeDetail(index)}
      >
        {`Delete ${ordinalNumber(index + 1)} Detail`}
      </Button>
    </div>
  );
};

Detail.propTypes = propTypes;
export default Detail;
